import type { CheckoutSession, SubscriptionPlan } from '../../types/models';

export const mockSubscriptionPlans: ReadonlyArray<SubscriptionPlan> = [
  {
    id: 'starter-monthly',
    name: 'Starter',
    price: 49,
    interval: 'monthly',
    features: [
      'Access to beginner-friendly coding tracks',
      'Weekly live Q&A with instructors',
      'Project templates and starter repos',
      'Community support and peer code reviews',
    ],
    stripePriceId: 'mock_starter_monthly',
  },
  {
    id: 'pro-monthly',
    name: 'Pro',
    price: 99,
    interval: 'monthly',
    features: [
      'Everything in Starter',
      'Intermediate + advanced full-stack tracks',
      'Portfolio project feedback from mentors',
      'Career prep: resume + interview drills',
      'Priority support',
    ],
    stripePriceId: 'mock_pro_monthly',
  },
  {
    id: 'career-annual',
    name: 'Career Accelerator',
    price: 899,
    interval: 'annual',
    features: [
      'Everything in Pro',
      '1:1 technical coaching sessions',
      'Capstone architecture review',
      'Mock interviews with senior engineers',
      'Private alumni network access',
    ],
    stripePriceId: 'mock_career_annual',
  },
];

export const createMockCheckoutSession = (planId: string): CheckoutSession => ({
  sessionId: `mock_session_${planId}_${Date.now()}`,
  url: `/pricing?checkout=mock&plan=${encodeURIComponent(planId)}`,
});

export const getMockSubscriptionStatus = (): { status: string; expiresAt?: string } => ({
  status: 'active',
  expiresAt: new Date(Date.now() + 1000 * 60 * 60 * 24 * 30).toISOString(),
});
